<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form @submit.prevent="submitForm()">
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Add a New Contact</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Select Account:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <AccountAutocomplete
                :key="companySearchComponentKey"
                class="searchbox"
                :list="searchAccount"
                :searchOn="'company_or_registration_no'"
                @event-name="handleChildEvent"
              ></AccountAutocomplete>
            </div>
            <span class="text-danger text-sm mt-2 ml-16">{{
              account_validation
            }}</span>
          </div>
          <!-- if satellite office is empty then contant lies on resitered office -->
          <div class="vx-row mb-6" v-if="showAddressField">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Address:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                name="satellite_address"
                label="satellite_address"
                :options="satellite_offices"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="contacts.satellite_address"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Title:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="title"
                v-model="contacts.title"
                v-validate="'required'"
                data-vv-as="Title"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('title')"
              >{{ errors.first("title") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Forename:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="forename"
                data-vv-as="Forename"
                v-validate="'required'"
                v-model="contacts.forename"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('forename')"
              >{{ errors.first("forename") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Surname:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="surname"
                data-vv-as="Surname"
                v-validate="'required'"
                v-model="contacts.surname"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('surname')"
              >{{ errors.first("surname") }}</span
            >
          </div>
          <!-- <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>DDI:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                name="ddi"
                data-vv-as="DDI"
                class="w-full"
                v-validate="'required'"
                v-model="contacts.ddi"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('ddi')"
              >{{ errors.first("ddi") }}</span
            >
          </div> -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Job Title:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input v-validate="'required'" name="job_title"  data-vv-as="Job Title"
class="w-full" v-model="contacts.job_title" />

            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('job_title')"
              >{{ errors.first("job_title") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Seniority:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                name="seniority"
                data-vv-as="Seniority"
                label="seniority"
                :options="contacts.seniorities"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="contacts.seniority"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Role:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                data-vv-as="Role"
                name="role"
                label="role"
                :options="contacts.roles"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="contacts.role"
              />
            </div>
           
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Sub Role:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                data-vv-as="Sub Role"
                name="sub_role"
                label="sub_role"
                :options="contacts.sub_roles"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="contacts.sub_role"
              />
            </div>
            
          </div>

          <div class="vx-row mb-6">

            <div class="vx-col sm:w-1/6 w-full">
              <h5 class="mb-5">Email                  

              </h5>



            </div>
            <div class="vx-col sm:w-1/5 w-full">

              <vs-button color="primary" @click="addEmail" type="filled"
                >Add</vs-button>
          </div>
          </div>
         

            <template 
            v-for="(email, index) in contacts.emails"
          >



        
          <div class="vx-row p-2">
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input
                class="w-full"
                name="email"
                v-model="email.email"
                data-vv-as="Email"
              />
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('email')"
                >{{ errors.first("email") }}</span
              >
            </div>
         

            <div class="vx-col sm:w-1/5 w-full">

              <vs-icon
              style="cursor:pointer;"
                  @click="validateEmailZeroBounce(email.email)"
                  color="success"
                  icon="checkmark"
                ></vs-icon>


              <!-- <vs-radio
              v-model="email.primary"
              :vs-value="email.primary"
              class="mr-4"
              vs-name="primary_email"
            ></vs-radio
            > -->


            <vs-icon
            class="removeButton"
            @click="removeSelectedEmail(email)"
            color="success"
            icon="clear"
          >
          </vs-icon>
          </div>
            
            </div>

           
            </template>
            {{ email_validate_status }}
        
          <vs-divider class="m-5" />


          <div class="vx-row mb-6">

            <div class="vx-col sm:w-1/6 w-full">
              <h5 class="mb-5">Social Media Pages    
              </h5>


            </div>
            <div class="vx-col sm:w-1/5 w-full">

              <vs-button color="primary" @click="addSocialMedia" type="filled"
                >Add</vs-button>
          </div>
          </div>
         

            <template
            v-for="(social_media, index) in contacts.social_medias"
          >

        
          <div class="vx-row">
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input
                class="w-full"
                name="social_media"
                v-model="social_media.social_media"
                data-vv-as="Social Media"
              />
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('social_media')"
                >{{ errors.first("social_media") }}</span
              >
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <vs-textarea
              v-model="social_media.summary"
            />

         

            
            
            
            </div>

            <div class="vx-col sm:w-1/5 w-full">

              <!-- <vs-radio
              v-model="social_media.primary"
              :vs-value="social_media.primary"
              class="mr-4"
              vs-name="primary_social_media"
            ></vs-radio
            > -->


            <vs-icon
            class="removeButton"
            @click="removeSelectedSocialMedia(social_media)"
            color="success"
            icon="clear"
          >
          </vs-icon>
          </div>
            
            </div>

           
            </template>
           
        
          <vs-divider class="m-5" />

          <div class="vx-row mb-6">

            <div class="vx-col sm:w-1/6 w-full">
              <h5 class="mb-5">DDI
              </h5>


            </div>
            <div class="vx-col sm:w-1/5 w-full">

              <vs-button color="primary" @click="addDDI" type="filled"
                >Add</vs-button>
          </div>
          </div>
         

            <template
            v-for="(ddi, index) in contacts.ddis"
          >

        
          <div class="vx-row p-2">
            <div class="vx-col sm:w-1/5 w-full">


              <v-select name="phone_code" class="phone_code" label="name_with_code" :options="all_phone_codes"
              :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="ddi.ddi_phone_code" />
            
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('ddi')"
                >{{ errors.first("ddi") }}</span
              >
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input
              class="w-full"
              name="ddi"
              v-model="ddi.ddi"
              data-vv-as="DDI"
            />

         

            
            
            
            </div>

            <div class="vx-col sm:w-1/5 w-full">

              <!-- <vs-radio
              v-model="ddi.primary"
              :vs-value="ddi.primary"
              class="mr-4"
              vs-name="primary_ddi"
            ></vs-radio
            > -->


            <vs-icon
            class="removeButton"
            @click="removeSelectedDDI(ddi)"
            color="success"
            icon="clear"
          >
          </vs-icon>
          </div>
            
            </div>

           
            </template>

          <vs-divider class="m-5" />

          <div class="vx-row mb-6">

            <div class="vx-col sm:w-1/6 w-full">
              <h5 class="mb-5">Mobile
              </h5>
          
          
            </div>
            <div class="vx-col sm:w-1/5 w-full">
          
              <vs-button color="primary" @click="addMobile" type="filled"
                >Add</vs-button>
          </div>
          </div>
          
          
            <template
            v-for="(mobile, index) in contacts.mobiles"
          >
          
          
          <div class="vx-row p-2">
            <div class="vx-col sm:w-1/5 w-full">
          
          
              <v-select name="phone_code" class="phone_code" label="name_with_code" :options="all_phone_codes"
              :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="mobile.mobile_phone_code" />
            
              <span
                class="text-danger text-sm mt-2 ml-16"
                v-show="errors.has('mobile')"
                >{{ errors.first("mobile") }}</span
              >
            </div>
            <div class="vx-col sm:w-1/5 w-full">
              <vs-input
              class="w-full"
              name="mobile"
              v-model="mobile.mobile"
              data-vv-as="Mobile"
            />
          
          
          
            
            
            
            </div>
          
            <div class="vx-col sm:w-1/5 w-full">
              
          
              <!-- <vs-radio
              v-model="mobile.primary"
              :vs-value="mobile.primary"
              class="mr-4"
              vs-name="primary_mobile"
            ></vs-radio
            > -->
          
          
            <vs-icon
            class="removeButton"
            @click="removeSelectedMobile(mobile)"
            color="success"
            icon="clear"
          >
          </vs-icon>
          </div>
            
            </div>
          
           
            </template>
            <vs-divider class="m-10" />

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
             <input type="submit" class="mr-3 mb-2 submit-button"
                >
              <!-- <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              > -->
            </div>
          </div>
        </vx-card>
      </form>
  
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import moduleContactsManagement from "@/store/contacts-management/moduleContactsManagement.js";
import vSelect from "vue-select";
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
export default {
  data() {
    return {
      email_validate_status: null,
      all_phone_codes:[],
      editContactpopupActive: false,
      viewContactpopupActive: false,
      emailExistspopupActive: false,
      existsEmailseditContacts: [],
      edit_primary_email: null,
      editContactDescription: {},
      showEditAddressField: false,
      edit_satellite_offices: [],
      edit_account_validation: null,
      edit_accounts: [],
      companySearchComponentKey: 0,
      abilities: null,
      editContacts: {
        account_id: null,
        primary_social_media: null,
        primary_mobile: null,
                primary_ddi: null,

        edit_primary_email: null,
        company_name: null,
        social_medias: [],
        mobiles: [],
                ddis: [],

        emails: [],
        title: null,
        forename: null,
        surname: null,
        email: null,
        job_title: null,
        ddi: null,
        mobile: null,
                ddi: null,

        seniority: null,
        role: null,
        sub_role: null,
        social_media: null,
        seniorities: [],
        sub_roles: [],
        satellite_address: {},
        satellite_office_id: null
      },
      editContactShowPopup: false,

      records: [],
      new_added_email: "fake@example.com",
      dataSource: {},
      abilities: null,
      editContactpopupActive: false,
      viewContactpopupActive: false,
      emailExistspopupActive: false,
      existsEmailsContacts: [],
      showAddressField: false,
      satellite_offices: [],
      account_validation: null,
      accounts: [],
      companySearchComponentKey: 0,
      abilities: null,
      contacts: {
        account_id: null,
        primary_social_media: null,
        primary_mobile: null,
                primary_ddi: null,

        primary_email: null,
        company_name: null,
        social_medias: [],
        mobiles: [],
                ddis: [],

        emails: [],
        title: null,
        forename: null,
        surname: null,
        email: null,
        job_title: null,
        ddi: null,
        ddi_phone_code: null,
        mobile: null,
        mobile_phone_code: null,
        seniority: null,
        role: null,
        sub_role: null,
        social_media: null,
                social_media_summary: null,

                joinedSocialMediaAndSummary: [],
                        socialMediaWithSummary: [],

        seniorities: [],
        sub_roles: [],
        satellite_address: null,
        satellite_office_id: null
      }
    };
  },
  components: {
    "v-select": vSelect,
    AccountAutocomplete,
    DataGrid
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule(
        "contactsManagement",
        moduleContactsManagement
      );
      moduleContactsManagement.isRegistered = true;
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }
  },
  watch: {
    "contacts.role"(val) {
      if (val) {
        this.contacts.sub_roles = [];
        this.getSubRole(val.id);
      }
    },
  },
  mounted() {
    this.getSeniority();
    this.getRoles();
    this.getAllPhoneCodes()

    // this.getVerticals();
  },
  beforeMount() {
  },
  methods: {
    addSocialMedia() {
      this.contacts.social_medias.push({
          social_media: null,
          summary: null,
          primary: false

        });
    },
    addEmail() {
  this.contacts.emails.push({
      email: null,
      primary: false

    });
},
addDDI() {
  this.contacts.ddis.push({
      ddi: null,
      ddi_phone_code: null,
      primary: false

    });
},
    addMobile() {
      this.contacts.mobiles.push({
          mobile: null,
          mobile_phone_code: null,
          primary: false

        });
    },
    removeSelectedSocialMedia(social_media) {
      this.contacts.social_medias = this.contacts.social_medias.filter(
        item => {
          return item != social_media;
        }
      );
    },
    removeSelectedEmail(email) {
      this.contacts.emails = this.contacts.emails.filter(
        item => {
          return item != email;
        }
      );
    },
    removeSelectedMobile(mobile) {
      this.contacts.mobiles = this.contacts.mobiles.filter(
        item => {
          return item != mobile;
        }
      );
    },
    removeSelectedDDI(ddi) {
    this.contacts.ddis = this.contacts.ddis.filter(
      item => {
        return item != ddi;
      }
    );
  },
    getAllPhoneCodes() {
      let self = this
      this.$store
        .dispatch("accountsManagement/getAllPhoneCodes")
        .then(response => {
          self.all_phone_codes = response.data
          self.all_phone_codes.forEach(function(ele){
            if(ele.phone_code){
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },

    closeThisWindow() {
      let self = this;
      self.viewContactpopupActive = false;
    },
    editHandleChildEvent() {
      this.edit_satellite_offices = [];
      this.edit_accounts = moduleAccountsManagement.state.edit_accounts.datas;
      this.getEditSatelliteOffices(this.edit_accounts[0].id);
    },
    searchEditAccount(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data =
              moduleAccountsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    removeEditSelectedPhone(selected) {
      this.editContacts.joinedPhoneAndTypes = this.editContacts.joinedPhoneAndTypes.filter(
        item => {
          return item != selected;
        }
      );
    },
    validDomain(userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        );
        if (res == null) {
          return false;
        }
      }
      return true;
    },
    handleChildEvent() {
      this.satellite_offices = [];
      this.accounts = moduleAccountsManagement.state.accounts.datas;
      this.getSatelliteOffices(this.accounts[0].id);
    },
    searchAccount(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data =
              moduleAccountsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    getSeniority() {
      this.$store
        .dispatch("contactsManagement/getSeniority")
        .then(res => {
          this.contacts.seniorities = res.data;
          console.log(this.contacts.seniorities);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getRoles() {
      this.$store
        .dispatch("contactsManagement/getRoles")
        .then(res => {
          this.contacts.roles = res.data;
          console.log(this.contacts.roles);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getSubRole(role_id) {
      this.$store
        .dispatch("contactsManagement/getSubRoles", role_id)
        .then(res => {
          this.contacts.sub_roles = res.data;
        })
        .catch(err => {
          console.error(err);
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    removeSelectedPhone(selected) {
      this.contacts.joinedPhoneAndTypes = this.contacts.joinedPhoneAndTypes.filter(
        item => {
          return item != selected;
        }
      );
    },
    validDomain(userInput) {
      if (userInput) {
        var res = userInput.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
        );
        if (res == null) {
          return false;
        }
      }
      return true;
    },


    validateEmailZeroBounce(email){
      let self = this

      if (email){
        self.$vs.loading();

        this.$store
        .dispatch("contactsManagement/validateEmailZeroBounce", email)
        .then(res => {
          self.email_validate_status = res.data
          self.$vs.loading.close();

         console.log(res)
        })
        .catch(err => {
          console.error(err);
        }).finally(() => {
              this.$vs.loading.close()
            })  
      }


     

    },
    submitForm() {
      let self = this;
      // self.addContacts();
      this.$validator.validateAll().then(result => {
        if (result) {
          if (self.accounts.length === 0) {
            self.account_validation = "The Account field is required";
            return false;
          } else {
            self.contacts.account_id = self.accounts[0].id;
            self.addContacts();
          }

          // if form have no errors
        } else {
          return false;
        }
      });
    },
    // getEmailExistsInDB(email) {
    //   let self = this
    //   self.$store
    //     .dispatch("contactsManagement/getEmailExistsInDB", email)
    //     .then(res => {
    //       if(res.data){
    //         this.emailExistspopupActive = true
    //         this.existsEmailsContacts = res.data
    //       }
    //     })
    //     .catch(err => {
    //       console.error(err);
    //     });
    // },
    getSatelliteOffices(account_id) {
      let self = this;
      self.$store
        .dispatch("accountsManagement/getSatelliteOffices", account_id)
        .then(res => {
          self.satellite_offices = res.data;
          if (self.satellite_offices.length != 0) {
            self.showAddressField = true;
            self.satellite_offices.forEach(function(ele) {
              ele.satellite_address =
                ele.address_1 + "," + ele.city + "," + ele.county;
              return ele;
            });
          } else {
            self.showAddressField = false;
          }
          console.log(self.satellite_offices);
        })
        .catch(err => {
          console.error(err);
        });
    },
    addContacts() {
      // console.log(this.contacts)
      // return false

      // if(Object.keys(this.contacts.satellite_address).length != 0){
      //   this.contacts.satellite_office_id = this.contacts.satellite_address.uuid
      // }else{
      //   this.contacts.satellite_office_id = null
      // }
      
      this.$store
        .dispatch("contactsManagement/addContacts", this.contacts)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Contact Added",
              text: "The contact was added successfully and added to campaign."
            });
            this.$router.push({ path: "/contacts" });
          }
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

.searchbox {
  width: 582px;
}

.submit-button{
  padding: .75rem 2rem;
    background: rgb(63, 62, 62) !important;
    font-family: "Montserrat", Helvetica, Arial, sans-serif;
    color: white;
    font-size: 1rem;
    -webkit-transition: all .2s ease;
    transition: all .2s ease;
    border: 0;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    color: #fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
</style>
